import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_AUDIT_OUTCOME_LIST = "GET_AUDIT_OUTCOME_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Admin/GetAuditOutcomeWithRiskAreaOutcome/${data.riskAreaOutcomeId}`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_AUDIT_OUTCOME_LIST, service, mock);
